import React, { useContext, useRef, useState } from 'react';
import { Spinner } from '../../../StyledComponent';
import { ButtonPrimary } from '../../../StyledComponent';
import { ContextoFinanceiro } from '../../../../services/financeiro';

import ShowBoleto from '../../ShowBoleto';

const MsgBotaoVisualizarBoleto = () => {
  return <span id={'visualizarBoleto'}>VISUALIZAR BOLETO</span>;
};

export default function BotaoVisualizarBoleto({
  seuNumero,
  bancoBoleto,
  tema,
  light,
  width,
  fullWidth,
  vencimentoBoleto,
  disabled,
}) {
  const [showPdfBoleto, setShowPdfBoleto] = useState(false);

  const [base64PdfBoleto, setBase64PdfBoleto] = useState('');

  const [loadingVisualizarBoleto, setLoadingVisualizarBoleto] = useState(false);
  const [error, setError] = useState(false);

  const { getVisualizarBoleto } = useContext(ContextoFinanceiro);

  const setMensagemVisualizarBoleto = () => {
    if (loadingVisualizarBoleto) {
      return (
        <>
          <MsgBotaoVisualizarBoleto /> <Spinner />
        </>
      );
    } else if (error) {
      return <small>Ocorreu um erro, tente novamente mais tarde.</small>;
    } else {
      return <MsgBotaoVisualizarBoleto />;
    }
  };

  async function getPDFVisualizarBoleto(Cod_banco, Seu_numero) {
    setLoadingVisualizarBoleto(true);
    let result = '';
    try {
      result = await getVisualizarBoleto(Cod_banco, Seu_numero);

      setBase64PdfBoleto(result.data);
      setShowPdfBoleto(true);
      executeScroll();
    } catch (error) {
      setError(true);
    } finally {
      setLoadingVisualizarBoleto(false);
      setTimeout(() => setError(false), 5000);
    }
  }

  const pdfBoleto = useRef(null);

  const executeScroll = () => pdfBoleto?.current?.scrollIntoView();

  const handleShowBoleto = async () => {
    await getPDFVisualizarBoleto(bancoBoleto, seuNumero);
  };
  return (
    <>
      <ButtonPrimary
        width={width}
        fullWidth={fullWidth}
        tema={tema}
        light={light}
        onClick={handleShowBoleto}
        disabled={loadingVisualizarBoleto || error || disabled}
      >
        {setMensagemVisualizarBoleto()}
      </ButtonPrimary>
      {showPdfBoleto && (
        <ShowBoleto
          showPdfBoleto={showPdfBoleto}
          setShowPdfBoleto={setShowPdfBoleto}
          base64PdfBoleto={base64PdfBoleto}
          pdfBoleto={pdfBoleto}
          vencimentoBoleto={vencimentoBoleto}
          tema={tema}
        />
      )}
    </>
  );
}
